import { FC, ReactNode } from 'react'
import { useFormContext, RegisterOptions } from 'react-hook-form'
import get from 'lodash/get'

import {
  InputGroup,
  Label,
  TextField as StyledTextField,
  ErrorLabel,
  Hint,
} from 'components/form'

type Props = {
  name: string
  label?: ReactNode
  type?: string
  hint?: ReactNode
  noMargin?: boolean
  lessMargin?: boolean
  readOnly?: boolean
  registerOptions?: RegisterOptions
}

const AuthTextField: FC<Props> = ({
  name,
  label,
  type = 'text',
  hint,
  noMargin,
  lessMargin,
  readOnly,
  registerOptions,
}) => {
  const {
    register,
    formState: { errors, isSubmitted },
  } = useFormContext()
  const error = get(errors, name)
  const showError = Boolean(error) && isSubmitted

  return (
    <InputGroup lessMargin={lessMargin} noMargin={noMargin}>
      {label && (
        <Label htmlFor={name} error={showError}>
          {label}
        </Label>
      )}
      {/* styled-components TextField doesn't recognize boolean error prop — see spec deviation notes */}
      <StyledTextField
        id={name}
        type={type}
        error={showError as any}
        readOnly={readOnly}
        {...(register(name, registerOptions) as any)}
      />
      {showError && (
        <ErrorLabel htmlFor={name}>{error?.message as string}</ErrorLabel>
      )}
      {hint && <Hint>{hint}</Hint>}
    </InputGroup>
  )
}

export default AuthTextField
